import React from 'react';
import { Pagination as MuiPagination, Box } from '@mui/material';

const Pagination = ({ count, page, onChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
      <MuiPagination
        count={count}
        page={page}
        onChange={onChange}
        color="primary"
        sx={{
          // Make pagination items white
          '& .MuiPaginationItem-root': {
            color: '#fff',
            borderColor: '#fff',
          },
          // Customize the selected (active) page item
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: '#00ff00',
            color: '#000',
          },
          // Style the ellipsis if it appears
          '& .MuiPaginationItem-ellipsis': {
            color: '#fff',
          },
        }}
      />
    </Box>
  );
};

export default Pagination;
